module.exports = __webpack_public_path__ + "img/mango-6.f22c4518.png";